{
	"title": "中沢 🐇🥕🐰",
	"description": "🐇🥕🐰",
	"buttons": {
		"fullscreen": "全画面",
		"achievements": "実績",
		"reset": "リセット",
		"language": "言語"
	},
	"achievements": {
		"title": "実績",
		"noAchievements": "まだ実績を獲得していません。クリックを続けましょう！",
		"unlocked": "実績解除：{{message}}",
		"progress": "{{progress}}%",
		"beginner": "🎯 初心者バニー",
		"carrotSnatcher": "🥕 野菜泥棒",
		"bunnyBerserker": "😡 狂乱のウサギ",
		"hopPunk": "🎸 アナーキーな綿尾",
		"bunnyNinja": "🥷 静かなる死のフワフワ",
		"expert": "🌟 エキスパートホッパー",
		"master": "👑 ニンジンキング",
		"carrotpocalypse": "🥕 菜園の破壊者",
		"bunnyOverlord": "😈 ウサギの群れの支配者",
		"chaosHare": "🌪️ 混沌のウサギ使い",
		"carrotCultist": "⛪ ニンジン教団の大司祭",
		"bunnyberryPie": "🥧 幻覚パイの達人",
		"rabbitHole": "🕳️ 量子トンネル掘り",
		"moonRabbit": "🌙 月の玉兎",
		"bunnyDoom": "💀 ウサポカリプスの使者",
		"carrotNuke": "☢️ 熱核ニンジン使い",
		"bunnyMatrix": "🤖 ウサギマトリックスの異常",
		"cosmicHare": "🌌 宇宙のウサギの覚醒",
		"warrenSingularity": "🕳️ 巣穴シンギュラリティ達成",
		"eternalBunny": "♾️ 永遠のウサギ"
	},
	"messages": {
		"prophecy": "古代のクリック予言が展開し始める...",
		"cosmic": "宇宙のクリッカーたちはあなたの進歩を誇りに思うでしょう！",
		"astral": "クリックが星界を響き渡る...",
		"speaking": "待って...聞こえた？クリックが私に話しかけている...",
		"ancient": "あなたのクリックが古代の力と共鳴する！",
		"sages": "クリックの賢者たちがあなたの可能性を囁いている...",
		"demons": "見よ！クリックの悪魔たちが目覚めた！",
		"veil": "あなたのクリックが現実の壁を突き破る！",
		"spirits": "クリックの精霊たちがあなたのリズムに合わせて踊る...",
		"council": "グランドクリック評議会があなたの献身に気付いた",
		"primordial": "あなたのクリックが原初の力を呼び覚ます！",
		"void": "クリックの虚空があなたを見返している...",
		"runes": "古代のクリックルーンがあなたの力で輝く！",
		"beast": "三三三 - クリック獣の数字",
		"prophets": "クリックの預言者たちがあなたの到来を歌う！",
		"dimensions": "あなたのクリックが次元を超えて響き渡る...",
		"portal": "あなたのクリックがクリック次元へのポータルを開いた！",
		"sacrifice": "古代のクリックの神々がさらなる生贄を求める",
		"jackpot": "ジャックポット！クリックカジノが新チャンピオンを歓迎する！",
		"unmatched": "あなたのクリック力は無敵です！",
		"reality": "現実そのものがあなたのクリックの意志に従う！",
		"elite": "あなたはエリートクリックマスターとなった",
		"power": "あなたのクリックパワーレベルは1500を超えた！",
		"devils": "クリックの悪魔たちがあなたの力の前に頭を垂れる",
		"lucky": "幸運のクリックがあなたの血管を流れる",
		"dynasty": "クリック王朝があなたの覇権を認める",
		"twoThousand": "純粋な力の2000クリック！",
		"quartet": "クリック四重奏の予言が成就した",
		"transcend": "あなたのクリックは人知を超越する",
		"constellation": "クリック星座があなたの栄誉のために整列する",
		"destiny": "運命の3000クリック",
		"triforce": "トリプルクリックトライフォースが目覚める！",
		"fortune": "幸運は執念深いクリッカーの味方",
		"newDimensions": "あなたのクリック力が新次元に到達する",
		"quartet2": "四重クリックカルテットが調和する",
		"threshold": "クリック神性の閾値に立つ",
		"ultimate": "究極の力の5000クリック！",
		"force": "五本指クリックフォースがあなたの指揮下に",
		"underworld": "クリック冥界があなたを支配者として戴冠する",
		"maxJackpot": "最大ジャックポットクリック達成",
		"infinite": "無限のクリックパワー！",
		"godhood": "あなたはクリック神性へと昇華した",
		"burrow": "他のどのウサギよりも深く掘り進んだ...",
		"warren": "大いなるウサギの巣穴があなたの存在を認める...",
		"thump": "あなたの足のスタンプで大地が震える！",
		"darkWarren": "闇の巣穴があなたのために門を開く...",
		"ears": "耳がどんどん長くなる...全てが聞こえるようになった...",
		"carrotThrone": "ニンジンの玉座があなたの前に現れる...",
		"onesAlignment": "全ての一が揃う - 巣穴の周波数が共鳴する！",
		"moonSummon": "月の兎が虚空を越えてあなたの呼び声を聞く...",
		"edgeOfForever": "永遠の淵に立つ...耳がヒクヒクと...",
		"beyondTheVeil": "ヴェールの向こう側で、全ての巣穴がひとつになる...",
		"sequence": "1-2-3-4-5...聖なるホップの配列が完成した！",
		"hyperElite": "ハイパーエリートバニーステータス解除 🐇🐇🐇",
		"eventHorizon": "宇宙のウサギの穴のイベントホライズンを越えて...",
		"matrixAwakens": "巣穴マトリックスがグリッチ...現実の裏側にニンジンが見える",
		"luckyForever": "全ての肉球、全てのジャンプ、全てのヒクヒク...永遠に祝福された",
		"twentyK": "二万。あなたはもはやウサギではない。あなたがウサギそのものだ。",
		"singularity": "バニー・シンギュラリティ。全てのウサギはあなた。あなたは全てのウサギ。",
		"tripleAscension": "宇宙のウサギの三重昇天！",
		"ultimateAnswer": "42,000 - 究極の答えは最初からニンジンだった",
		"eternity": "♾️ 永遠の巣穴に終わりはない。あなたにも。♾️"
	},
	"powerups": {
		"bonusPoints": "🥕 +{{count}} ボーナスポイント！",
		"clickStreak": "🔥 {{count}}連続クリック！",
		"fire": "🔥 ファイヤーパワー発動！"
	},
	"table": {
		"achievement": "実績",
		"progress": "進捗"
	},
	"reset": {
		"confirm": "本当に全ての進行状況をリセットしますか？この操作は取り消せません。"
	}
}
